// extracted by mini-css-extract-plugin
export var closeButtonContainer = "main-module--closeButtonContainer--Sj76K";
export var container = "main-module--container--gBOhI";
export var description = "main-module--description--+CGrZ";
export var donation = "main-module--donation--ccGS6";
export var errormessage = "main-module--errormessage--Sokac";
export var nameheader = "main-module--nameheader--CMPwO";
export var outercontainer = "main-module--outercontainer--+TCAO";
export var smaller = "main-module--smaller--6vZV3";